import React, { Component } from 'react';
import { escapeStringRegexp } from 'utils/escape-string-regexp';
import { FaqContainer, FaqItem } from 'components/shared/faq-item';
import Input from 'components/shared/input';
import styles from './styles.module.scss';

const questionsAndAnswers = [
  [
    'How much does Unyted cost?',
    'That depends on the service. School platform costs depend on number of students. For certain qualifying schools, it may be free! SEL Power Skills Workshop costs also range depending on audience size, but may be free. Unyted Learning Center (out-of-school services akin to tutoring and coaching) costs depend on the plan parents purchase. ',
  ],
  [
    'What unique value does Unyted provide?',
    'We offer a patent-pending online method that gets learners solve problems in groups. This process helps learners understand academic topics faster, but also guides and trains them in key skills. learners Specifically, we make SEL Power Skills a part of academic learning instead of apart from academic learning. So, it can be done efficiently (resources), effectively (data-backed results) and consistently (fidelity).',
  ],
  [
    'What is Social-Emotional Learning?',
    'Social-emotional Learning (SEL) is the process by which we, yes, ALL OF US (not just students), develop key competencies like self-awareness, self-management, social-awareness, relationship skills, responsible decision-making, etc. Within each of these competencies are a number of "Power Skills" needed to learn faster and also apply knowledge in real world situations.',
  ],
  [
    'What are some of the controversies or debates around the subject?',
    'Commentators generally accept the growing evidence that SEL is needed in some form, boosts student achievement and helps learners and teachers reach their goals. But, many are concerned about limited resources, misconceptions, and time needed away from academic instruction. In short, there is controversy as to relevancy and whether or not SEL is "fluff."',
  ],
  [
    'What makes Unyted different in terms of academics and SEL?',
    'We are the optimal option for excelling at both *at the exact same time*. No time needed away from academic instruction. Both explicit and integrated SEL Power Skills instruction is woven into lessons. We "unite" (Unyted) the two key areas of learner development and eliminate the need to add "one more thing" to an educator\'s tasks or parent costs.',
  ],
  [
    'How is it possible to consistently integrate academics and SEL when almost every other program requires at least some time set aside for SEL curriculum or a separate program?',
    'SEL is often misunderstood or misapplied. At its core, SEL is about developing evidence-based core competencies (non-academic in nature, yet used in applying that knowledge!) and the underlying "Power Skills" within each competency. The TEAM Method helps educators change the format of how lessons are delivered to and experienced by learners. Within these unique collaborative, academic scenarios (e.g. learning Math, Science, ELA), our technology aides teachers to guide learners. The result is learners who more naturally practice and develop "Power Skills" to use in real-world settings.',
  ],
  [
    'Does our whole school need to implement Unyted?',
    'While there are countless benefits - from school culture down to personalized behavioral improvements for each student - when an entire school uses Unyted to learn, you may also wish to begin or target specific classes or populations within your community. Many times, 1-2 "champions" are selected first and get momentum going in a school or community.',
  ],
  [
    'As a parent, how do I know if my child has access to Unyted and SEL Power Skills?',
    'The first place to check is at school. If the school is not a Unyted partner, chances are there are some gaps. For those reasons, we created a Unyted Learning Center service direct to parents. Please contact us.',
  ],
  [
    'Does Unyted help with anti-bullying initiatives?',
    "Unyted explicitly aims to place students in collaborative scenarios with <strong>true</strong> interdependence between peers. On multiple levels, relationships are at the core of Unyted's mission. With these continued opportunities for students to execute together, we have seen consistent evidence of reduced bullying and cooperation that extends even outside of the classroom! Contact us to connect you with teachers and admin who have experienced the positive impact.",
  ],
  [
    'As a school educator, can I only begin this at the beginning of a school year?',
    'No way! Unyted is flexible enough to be used at any point - we even have schools who begin participation for end of semester or end-of-course (EOC) review sessions. Of course, the more exposure to Unyted activities, the more benefits, but reach out to us to start at any time.',
  ],
  [
    'How do teachers and staff become trained enough to implement Unyted for students?',
    'We focus our support - in-person, webinar and automated (via video tutorials) - on professional development (PD) needed for all teachers to be well-prepared for immediate success. With years of PD training experience and countless helper videos, our expertise is in getting teachers ready as quickly and easily as possible. Usually it takes no longer than an hour to be up and running!',
  ],
  [
    'What if I am not a "techie" teacher or comfortable with technology?',
    'No problem at all! So much of the process is already automated for you! If you can browse the internet and minimally use a computer, you have all the "tech" skills needed. Plus, our support is always available to you online or in-person.',
  ],
  [
    'How long does the professional development process usually take?',
    'Some teachers have begun with less than 30 minutes of training and review. Usually, it takes no more than 60 minutes of experimentation to get started!',
  ],
  [
    'What is the age range for student use? Any age restrictions?',
    "It depends!  There is not any specific restriction. If a student can use a device, they can benefit from Unyted. For in-school students, we generally encourage use for 3rd grade and up since part of the process is developing the higher order thinking and problem solving usually best supported by 3rd grade reading and writing levels. There are exceptions, of course. We've recently seen successful use at 1st grade and lower. For use at home by parents and tutors, we've seen almost all age ranges!",
  ],
  [
    'What about lower performing students? Does this process only work with "high-performing" students?',
    'Our process is proven to help both high performers and very quickly boost lower performing students for almost unbelievable gains from leveraging the power of their teams and the interactions within a truly interdependent, collaborative setting. Contact us to show you the science and research backing it up!',
  ],
  [
    'Does Unyted align with CASEL and their leading research base?',
    'Unyted goes beyond "aligning" with the research of the Collaborative for Academic, Social, and Emotional Learning (CASEL). We explicitly promote the development of their evidence-based, core 5 standards and corresponding skills. No interpretation or abstraction from the research-base in order to create a separate program or our "opinion" of an appropriate SEL curriculum. Instead, we directly help develop the skills from the leading research base. And, most importantly, in the optimal context: practiced and developed in sequence, via active learning, focused on core SEL skills, and explicit targeting of those core 5 easier for all involved.',
  ],
  [
    'How do I get started right away?',
    <div class="d-flex flex-column">
      <p>
        <a href="mailto:info@unyted.co?subject=I'm interested in Unyted!">
          Contact us
        </a>{' '}
        directly and we will get you started within 24 hours (on any business
        day). It is really that easy to begin your Unyted community.
      </p>
    </div>,
  ],
];

export default class FAQPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filter: '',
    };

    this.setFilter = this.setFilter.bind(this);
  }

  setFilter(e) {
    this.setState({ filter: e.target.value });
  }

  render() {
    const searchRegExp = new RegExp(escapeStringRegexp(this.state.filter), 'i');
    const filteredQuestionsAndAnswers = questionsAndAnswers.filter(
      ([question, answer]) =>
        searchRegExp.test(question) || searchRegExp.test(answer),
    );

    return (
      <div className={`${styles.faqPage}`}>
        <section className={`benefits-section ${styles.header} text-center`}>
          <div className={styles.contentWrapper}>
            <h3>Frequently Asked Questions</h3>
            <p>Answers to common questions</p>
          </div>
        </section>
        <section className="benefits-section white">
          <div className="container">
            <div className="d-flex mb-3 justify-content-center">
              <Input
                className="w-75"
                icon="search"
                placeholder="Search FAQs"
                onChange={this.setFilter}
                value={this.state.filter}
              />
            </div>
            <div id="accordion">
              <FaqContainer>
                {filteredQuestionsAndAnswers.map(([question, answer]) => (
                  <FaqItem question={question}>{answer}</FaqItem>
                ))}
              </FaqContainer>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
